import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import React from "react";
import { useDisputeModal } from "../InitiateDisputeModal/store/useDisputeModal";
import { DisputePaymentModalFooter } from "./modules/DisputePaymentModalFooter/DisputePaymentModalFooter";

export const DisputePaymentModal = ({ value }) => {
  const { selectedRecords } = value;

  const record = Object.values(selectedRecords)[0];
  const open = useDisputeModal((state) => state.isOpenDisputePaymentModal);
  const setOpen = useDisputeModal(
    (state) => state.setIsOpenDisputePaymentModal
  );

  return (
    <ExlyModal
      title="Dispute Payment"
      open={open}
      onClose={() => setOpen(false)}
      modal_props={{
        modalPaperClassName: "!tw-min-w-[450px]",
      }}
      customFooter={<DisputePaymentModalFooter record={record} />}
    >
      <div className="tw-pt-[20px] tw-pb-[10px]">
        <label className="tw-font-bold tw-text-[#493ab1] tw-pl-[8px] tw-pb-[5px] !tw-m-0">
          Reason for dispute
        </label>
        <div className="tw-bg-gray-100 tw-border tw-shadow-sm tw-rounded-lg tw-p-3 tw-text-gray-700 tw-font-medium">
          {record?.dispute_reason}
        </div>

        <div className="tw-flex tw-text-[14px] tw-text-[#625f72] tw-mt-[20px] tw-pl-[8px] tw-font-medium">
          <span>
            This dispute has been re-raised. A dispute fee is applicable and
            must be paid before continuing.
          </span>
        </div>
      </div>
    </ExlyModal>
  );
};
